import ApiBuilder from '../helpers/ApiBuilder';
import { Log, UserManager, WebStorageStateStore } from 'oidc-client';
import StorageService from './StorageService';

const isBrowser = typeof window !== 'undefined';

export const userManagerConfigs = {
  authority: process.env.IDS_AUTHORITY,
  client_id: process.env.OIDC_CLIENT_ID,
  redirect_uri: process.env.REDIRECT_URI,
  post_logout_redirect_uri: process.env.POST_LOGOUT_REDIRECT_URI,
  silent_redirect_uri: process.env.SILENT_REDIRECT_URI,
  automaticSilentRenew: true,
  response_type: 'code',
  scope: 'profile openid AppFramework IdentityAPI DevPortalAPI',
  filterProtocolClaims: true,
  loadUserInfo: true,
  userStore: isBrowser ? new WebStorageStateStore({ store: StorageService.getStorageInstance() }) : null,
};


class AuthService {
  constructor() {
    this.userManager = isBrowser ? new UserManager({
      ...userManagerConfigs,
    }) : null;

    if (process.env.NODE_ENV === 'development') {
      Log.logger = console;
      Log.level = Log.INFO;
    }
  }

  getUser = () => {
    return this.userManager ? this.userManager.getUser() : null;
  }

  login = () => {
    return this.userManager ? this.userManager.signinRedirect() : null;
  }

  renewToken = () => {
    return this.userManager ? this.userManager.signinSilent() : null;
  }

  logout = () => {
    return this.userManager ? this.userManager.signoutRedirect() : null;
  }

  logoutSilently = async () => {
    try {
      const user = await this.getUser()
      const req = await this.userManager.createSignoutRequest({ id_token_hint: user.id_token })
      document.getElementById('silentLogout').setAttribute('src', req.url);
    }
    catch (e) {
      // if error fail silently
    }
  }

  removeUser = () => {
    return this.userManager ? this.userManager.removeUser() : null;
  }
}

const getUserSession = (companyKey) => {
  return ApiBuilder.API.get('/api/biz/users?action=current-session', { headers: { 'CompanyKey': companyKey } });
};

export default {
  authServiceInstance: AuthService,
  getUserSession,
};